import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "dftb26_access_token";

export const tokenStore = {
  get: () => {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
  },
  set: (v) => {
    try { if (v) localStorage.setItem(TOKEN_KEY, v); } catch {}
  },
  clear: () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch {}
  },
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Mobile Safari (iOS) often blocks SameSite=None cross-site cookies via ITP.
// Attach the stored access_token as a Bearer header so auth still works there.
api.interceptors.request.use((config) => {
  const tok = tokenStore.get();
  if (tok) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${tok}`;
    }
  }
  return config;
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
